/**
 * Formats a product type code into a display label.
 * Replaces underscores and other non-alphanumeric characters with spaces and capitalises each word.
 * Handles Shopify-style breadcrumb paths (containing `>` or `--`) by formatting each segment
 * independently and joining them with ` > ` (e.g. "Apparel & Accessories > Clothing" stays readable).
 */
export function formatProductType(value: string | null | undefined): string {
  if (value == null || value === "") return "";

  const formatSegment = (segment: string): string =>
    segment
      .replace(/[^a-zA-Z0-9]+/g, " ")
      .trim()
      .toLowerCase()
      .replace(/(?:^|\s)\S/g, (c) => c.toUpperCase());

  const raw = value.trim();
  if (raw.includes(">") || raw.includes("--")) {
    const breadcrumbParts = raw
      .replace(/--+/g, ">")
      .split(">")
      .map((segment) => formatSegment(segment))
      .filter(Boolean);
    if (breadcrumbParts.length > 0) return breadcrumbParts.join(" > ");
  }
  return formatSegment(raw);
}

export function formatProductTypeDomainName(
  value: string | null | undefined,
): string {
  if (value == null || value === "") return "";

  const raw = value.trim();
  const breadcrumbParts = raw
    .replace(/--+/g, ">")
    .split(">")
    .map((segment) => segment.trim())
    .filter(Boolean);

  return formatProductType(breadcrumbParts.at(-1) ?? raw);
}
